<script>
import Layout from '@layouts/main.vue'
import BasePopover from '@components/_base-popover.vue'
import BaseConnections from '@components/_base-conections.vue'
import BaseVidPLayer from '@components/_base-vidplayer.vue'
import VideoModal from '@components/video-modal.vue'
import BlankButton from '@components/blank-button.vue'

export default {
  page: {
    title: '02 01 Planning Location A',
    meta: [
      { name: 'description', content: 'The 02 00 Planning Location Page.' },
    ],
  },
  components: {
    Layout,
    BasePopover,
    BaseConnections,
    BaseVidPLayer,
    VideoModal,
    BlankButton,
  },
  data() {
    return {
      disPlayVideo: false,
      refresh: 0,
    }
  },
  methods: {
    prevSlide() {
      this.fadeStage()
      setTimeout(() => {
        this.$router.push('/01-C-resource-model')
      }, 1500)
    },
    openModal() {
      this.disPlayVideo = true
      this.refresh++
    },
    closedModal() {
      this.disPlayVideo = false
    },
    fadeStage() {
      this.$refs.fadeStage.classList.add('go')
    },
  },
}
</script>

<template>
  <Layout way-name="Planning" next-loc="" next-title="Choose Your Path">
    <BaseVidPLayer
      ref="bgVideo"
      src="1D_RockCharacterization.mp4"
      poster="journey1-D.png"
      next-path="choose-path"
      :pause="2"
    />
    <BlankButton
      blank-height="125px"
      blank-width="230px"
      blank-x="0"
      blank-y="65px"
      @click.native="nextSlide"
    />
    <BlankButton
      blank-height="125px"
      blank-width="105px"
      blank-x="235px"
      blank-y="65px"
      @click.native="prevSlide"
    />

    <div ref="fadeStage" class="fadeStage">
      <BaseConnections d-val="M0,0, L36,34, L26,81 L15,100" />
      <BasePopover
        pos-orient="bottom-right"
        :position="[130, 200]"
        id-name="box1"
        class-name="box1Class"
        box-color="white"
        hotspot-id="hotspotting"
        hotspot-class="hotspotting"
        :hot-spot-x="33.8"
        :hot-spot-y="66"
        delay-start="1000"
      >
        <div class="flex m-b-15">
          <div class="m-r-10">
            <img
              :src="require('@assets/images/map-icon.png')"
              alt="map-icon"
              style="height: 55px;"
            />
          </div>
          <div>
            <h5>02 PLANNING: LOCATION D</h5>
            <h2>ROCK CHARACTERIZATION</h2>
          </div>
        </div>
        <p>
          Determine fracture and fault structures <br />directly from drillhole
          data with Split. <br /><br />
          Allows geotech to accurately refine <br />resource model.
        </p>
      </BasePopover>
      <BasePopover
        pos-orient="bottom-right"
        :position="[200, 490]"
        id-name="box2"
        class-name="box2Class"
        box-color="black"
        hotspot-id="hotspotting2"
        hotspot-class="hotspotting2"
        :hot-spot-x="33.8"
        :hot-spot-y="66"
        delay-start="5000"
      >
        <div>
          <img
            :src="require('@assets/images/vid-placeholder.png')"
            @click="openModal"
          />
        </div>
      </BasePopover>

      <BasePopover
        pos-orient="top-right"
        :position="[200, 750]"
        id-name="box3"
        class-name="box3Class"
        hotspot-id="hotspotting3"
        hotspot-class="hotspotting3"
        :hot-spot-x="33.8"
        :hot-spot-y="66"
        delay-start="6000"
      >
        <div>
          <h3>SPLIT FX</h3>
        </div>
      </BasePopover>

      <BaseHotspot
        spot-size="mid"
        :pos-x="30"
        :pos-y="60"
        pos-unit="%"
        :rot-x="0"
      />
      <VideoModal :key="refresh" :display="disPlayVideo">
        <Button type="primary" class="closeBtn" @click="closedModal">X</Button>
        <video
          ref="videoPlayerModal1"
          width="100%"
          height="100%"
          :src="require('@assets/videos/journey-2.mp4')"
          autoplay
        ></video>
      </VideoModal>
    </div>
  </Layout>
</template>

<style lang="scss">
@import '@design';

.fadeStage {
  opacity: 1;
  transition: opacity 1s;

  &.go {
    opacity: 0;
  }
}
</style>
